import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(normalLayout)/definition/BuildingDistinctions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(normalLayout)/definition/BuildingList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/definition.module.scss");
